import { ClockWorkAnalyticsModule } from "@/store/modules/clockWorkAnalytics.module";
import { assign, Machine } from "xstate";
const clockWorkAnalyticsMachine = Machine({
    id: "clockWorkAnalyticsMachine",
    initial: "idle",
    context: {
        formattedDateForFileName: "",
    },
    states: {
        idle: {
            always: {
                target: "gettingTeams",
            },
        },
        gettingTeams: {
            tags: "gettingTeams",
            invoke: {
                id: "gettingProjectList",
                src: () => {
                    return ClockWorkAnalyticsModule.GetTeams();
                },
                onDone: { target: "loadedTeams" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedTeams: {
            tags: "loadedTeams",
            on: {
                GETTING_CLOCKWORK_ANALYTICS: { target: "gettingClockworkAnalytics", actions: "assignformattedDateForFileName" },
            },
        },
        gettingClockworkAnalytics: {
            tags: "gettingClockworkAnalytics",
            invoke: {
                id: "gettingProjectList",
                src: (context, event) => {
                    return ClockWorkAnalyticsModule.GetClockWorkAnalytics(event.clockWorkAnalyticsRequest);
                },
                onDone: { target: "loadedClockWorkAnalytics" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedClockWorkAnalytics: {
            tags: "loadedClockWorkAnalytics",
            on: {
                GETTING_CLOCKWORK_ANALYTICS: { target: "gettingClockworkAnalytics" },
                EXPORT_CLOCKWORK_ANALYTICS: { target: "exportClockWorkAnalytics" },
            },
        },
        exportClockWorkAnalytics: {
            tags: "exportClockWorkAnalytics",
            invoke: {
                id: "exportClockWorkAnalytics",
                src: (context, event) => {
                    return ClockWorkAnalyticsModule.GetClockWorkAnalyticsAsReport(event.clockWorkAnalyticsRequest);
                },
                onDone: { target: "loadedClockWorkAnalytics", actions: "downloadExcel" },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        downloadExcel: (context, event) => {
            const blob = new Blob([ClockWorkAnalyticsModule.excelBlob], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = `${"ClockWorkAnalytics" + "-" + context.formattedDateForFileName}.xlsx`;
            link.click();
        },
        assignformattedDateForFileName: assign({
            formattedDateForFileName: (context, event) => {
                return event.formattedDate;
            },
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default clockWorkAnalyticsMachine;
